import { CardBody, Col, Row, Table } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { map } from "lodash";
import React from "react";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";

const TemplateDefault = ({
  classification,
  table_data,
  notCustomColls,
  ClientColls,
  handleChangeTable,
  total_in_custom_currency,
  base64Image,
  invoiceData,
  langUA,
  grandTotalWithTax,
}) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h4 className="font-size-18">{invoiceData.supplier_name}</h4>
          <address>{invoiceData.supplier_street}</address>
        </Col>
        <Col xs={12} className="mt-3">
          <h4 className="font-size-24">
            {langUA ? "Рахунок №" : "Invoice #"}
            {invoiceData.number}
          </h4>
          <address>
            <b>{langUA ? "Від" : "TO"}: </b> {invoiceData.date_issue}
          </address>
        </Col>
        <Col xs={6}>
          <address className="">
            <strong>{langUA ? "Платник" : "TO"}: </strong> <br />
            <span>{invoiceData.customer_name}</span>
            <br />
            {/* <span>{invoiceData.supplier_nameд}</span> */}
            {/* <span>{invoiceData.customer_street}</span> */}
          </address>
        </Col>
        <Col xs={6} className="text-end">
          <address>
            <strong>
              {langUA
                ? "Інформація для виставлення рахунків"
                : "Billing information"}
            </strong>
            <br />
            {langUA ? "Назва банку" : "Bank name"}: {invoiceData.bank_name}{" "}
            {/* Bank name */}
            <br />
            {invoiceData.bank_street} {/* Bank address */}
            <br />
            {langUA ? "Номер рахунку:" : "Account No."}{" "}
            {invoiceData.bank_account_number} {/* Account № */}
            <br />
            {invoiceData?.bank_edrpou &&
              `${langUA ? "ЄДРПОУ" : "EDRPOU"} ${invoiceData.bank_edrpou}`}
            <br />
            {invoiceData.bank_swift_bic &&
              `${langUA ? "SWIFT" : "Swift code"}: ${
                invoiceData.bank_swift_bic
              }`}{" "}
            {/* SWIFT */}
          </address>
        </Col>
        <Col xs={12} className="d-none">
          <address>
            <strong>Project</strong>
            <br />
            {invoiceData.customer_name} {/* Bank name */}
          </address>
        </Col>
      </Row>

      <Row className="d-none">
        <Col xs="6">
          <address>
            <span>{invoiceData.date_issue}</span>
          </address>
        </Col>
        <Col xs="6" className="text-end">
          <address className="mt-2 mt-sm-0">
            <strong>{langUA ? "Клієнт" : "The client"}:</strong>
            <br />
            <span>{invoiceData.customer_name}</span>
            <br />
            <span>{invoiceData.customer_street}</span>
          </address>
        </Col>

        <Col xs="6" className="mt-3">
          <address>
            <strong>
              {langUA ? "Банківські реквізити" : "Bank information"}:
            </strong>
            <br />
            {invoiceData.bank_name} {/* Bank name */}
            <br />
            {invoiceData.bank_account_number} {/* Account № */}
            <br />
            {invoiceData.bank_swift_bic} {/* SWIFT */}
            <br />
            {invoiceData.bank_street} {/* Bank address */}
          </address>
        </Col>
        <Col xs="6" className="mt-3 text-end">
          <address>
            <strong>{langUA ? "Підрядник" : "The contractor"}:</strong>
            <br />
            {invoiceData.supplier_name}
            <br />
            {invoiceData.supplier_street}
          </address>
        </Col>
        <Col xs="6" className="mt-3">
          <address>
            <strong>{langUA ? "Платник" : "TO"}:</strong>
            <br />
            {/* {invoiceData.customer_name} Customer name */}
            <br />
            {/* {invoiceData.customer_street} Customer street */}
            <br />
            {/* {invoiceData.customer_settlement_account}{" "} */}
            {/* Settlement_account */}
            <br />
            {invoiceData.customer_inn} {/* INN */}
          </address>
        </Col>
      </Row>
      <Row className="mt-3">
        {invoiceData && (
          <ReactTableForm
            columns={
              classification !== "CUSTOM" && classification !== "USER"
                ? notCustomColls
                : ClientColls
            }
            data={{
              results:
                classification !== "CUSTOM" && classification !== "USER"
                  ? table_data
                  : invoiceData?.items.map(i => {
                      return {
                        ...i,
                        custom_unit_price: langUA
                          ? i.custom_unit_price.split(" ")[0] + " ГРН"
                          : i.custom_unit_price,
                        date_from: invoiceData.date_from,
                        date_to: invoiceData.date_to,
                      };
                    }),
            }}
            onTableChange={handleChangeTable}
          />
        )}
        {/* <h5 className="m-0 text-start">
                        PAYMENT AMOUNT: {invoiceData.total} ({" "}
                        {invoiceData?.total_in_words} )
                      </h5> */}
        {invoiceData.show_tax && invoiceData?.tax_type && (
          <h6 className="m-0 text-end">
            {invoiceData.tax_type}: {invoiceData.tax_rate}%
          </h6>
        )}
        <h4 className="m-0 text-end">
          {/*total_in_custom_currency*/}
          {langUA ? (
            <>
              До сплати:{" "}
              {invoiceData.show_tax ? grandTotalWithTax(
                invoiceData.total_in_the_selected_currency,
                invoiceData.tax_rate
              ) : invoiceData.total_in_the_selected_currency}
              {" "}
              {total_in_custom_currency?.split(" ")[1]}
            </>
          ) : (
            <>
              Grand total:{" "}
              {invoiceData.show_tax ? grandTotalWithTax(
                invoiceData.total_in_the_selected_currency,
                invoiceData.tax_rate
              ) : invoiceData.total_in_the_selected_currency}
              {" "}
              {total_in_custom_currency?.split(" ")[1]}
            </>
          )}{" "}
          {/* contractor.balance_currency */}
        </h4>
      </Row>
      <div className="py-2 mt-3"></div>
      <div className="table-responsive">
        <Table className="table-nowrap">
          <thead>
            <tr>
              <th style={{ width: "70px" }}></th>
              <th></th>
              <th></th>
              <th className="text-end"></th>
            </tr>
          </thead>
          <tbody>
            {map(invoiceData.item_set, (item, key) => (
              <tr key={item.id}>
                <td className="text-end"></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <StyledRow
        id="signature__preview_invoice"
        className="row align-items-center"
      >
        <Col xl={4} className="text-start d-flex align-items-center">
          <h4 className="ml-5">
            <span className="text-decoration-underline">
              {langUA ? "Директор" : "Director"}
            </span>{" "}
            {invoiceData.supplier_signer}
          </h4>
        </Col>
        <Col
          xl={4}
          style={{ height: 110 }}
          className="d-flex justify-content-center align-items-center"
        >
          <img
            id="signature__preview_image"
            src={base64Image || ""}
            alt="signature__preview_image"
          />
          {/* <StyledImage
                          src={invoiceData.suplier_signature || ""}
                        /> */}
        </Col>
        <Col xl={4} className="align-items-center"></Col>
      </StyledRow>
    </React.Fragment>
  );
};

const CardBodyStyled = styled(CardBody)`
  @media print {
    .no-print {
      display: none;
    }
  }
`;

const StyledImage = styled.div`
  background-image: url(${props => props.src});
  background-size: cover;
  width: 250px;
  height: 250px;
`;

const StyledRow = styled.div`
  margin-bottom: 20px;

  img {
    width: auto;
    height: 110px;
  }

  h4 {
    margin-left: 15px;
    margin-bottom: 0;
  }
`;

TemplateDefault.propTypes = {
  classification: PropTypes.any,
  table_data: PropTypes.object,
  notCustomColls: PropTypes.any,
  ClientColls: PropTypes.any,
  handleChangeTable: PropTypes.func,
  total_in_custom_currency: PropTypes.any,
  base64Image: PropTypes.any,
  invoiceData: PropTypes.object.isRequired,
  langUA: PropTypes.boolean,
  grandTotalWithTax: PropTypes.func,
};

export default TemplateDefault;
